import { combineReducers } from 'redux';
import auth from './auth';
import brands from './brands';
import stationInfo from './station-info';
import reviews from './reviews';
import badgeAds from './badge-ads';
import nearby from './nearby';
import spotters from './spotters';
import fuels from './fuels';
import amenities from './amenities';
import stationHours from './station-hours';
import geoIp from './geo-ip';
import trends from './trends';
import analytics from './analytics';
import fuelReport from './fuelReport';
import user from './user';
import preferences from './preferences';
import config from './config';
import contests from './contests';
import geocode from './geocode';
import vehicleMakes from './vehicle-makes';
import vehicleModels from './vehicle-models';
import vehicleRecalls from './vehicle-recalls';
import vehicleProfile from './vehicle-profile';
import vehicles from './vehicles';
import offers from './offers';
import emergencyStatusHistory from './emergency-history';
import marketing from './marketing';
import ubi from './ubi';
import geo from './geo';
import favorites from './favorites';
import membership from './membership';
import fuelLogs from './fuelLogs';
import fuelEconomyStats from './fuelEconomyStats';
import home from './home';
import cms from './cms';

export default combineReducers({
  auth,
  brands,
  stationInfo,
  reviews,
  badgeAds,
  nearby,
  spotters,
  fuels,
  amenities,
  stationHours,
  geoIp,
  trends,
  analytics,
  fuelReport,
  user,
  preferences,
  config,
  contests,
  geo,
  geocode,
  vehicleMakes,
  vehicleModels,
  vehicleRecalls,
  vehicleProfile,
  vehicles,
  offers,
  emergencyStatusHistory,
  marketing,
  ubi,
  favorites,
  membership,
  fuelLogs,
  fuelEconomyStats,
  home,
  cms,
});
